import { locationType } from "../../core-utils/src/types";
import LocationIcon from "../../location-icon/src";
import PropTypes from "prop-types";
import React, { Component } from "react";
import i18n from "../../../../i18nSetup";

import { LocationPickerSpan, FromToPickerSpan } from "./styled";
import Button from "@mui/material/Button";
import {ReactComponent as ArrowBackIcon} from "../../../assets/arrowBack.svg";
import Link from "@mui/material/Link";
import IconButton from "@mui/material/IconButton";
import {ReactComponent as RefreshIcon} from "../../../assets/refresh.svg";
import Typography from "@mui/material/Typography";
import moment from "moment";
import {getUserTimezone} from "../../core-utils/src/time";
import Stack from "@mui/material/Stack";

const iconSize = "0.9em";

class FromToLocationPicker extends Component {
  onFromClick = () => {
    const { location, onFromClick, setLocation } = this.props;
    if (onFromClick) {
      onFromClick();
      return;
    }
    setLocation({
      location,
      locationType: "from",
      reverseGeocode: false
    });
  };

  onToClick = () => {
    const { location, onToClick, setLocation } = this.props;
    if (onToClick) {
      onToClick();
      return;
    }
    setLocation({
      location,
      locationType: "to",
      reverseGeocode: false
    });
  };

  render() {
    const {  showIcons} = this.props;
    return (
      <div>
        <Stack direction="row" alignItems="center" gap={1}>
          {showIcons && <LocationIcon type="from" size={iconSize}/>}
          <Link
            component="button"
            variant="body2"
            underline="hover"
            sx={{color: '#4B33A5'}}
            onClick={this.onFromClick}
          >
            {i18n.t('fromHere')}
          </Link>

          {showIcons && <LocationIcon type="to" size={iconSize}/>}
          <Link
            component="button"
            variant="body2"
            underline="hover"
            sx={{color: '#4B33A5'}}
            onClick={this.onToClick}
          >
            {i18n.t('toHere')}
          </Link>
        </Stack>
      </div>
    );
  }
}

FromToLocationPicker.propTypes = {
  /**
   * The text to display on the "from" button for setting the origin of a trip.
   */
  fromText: PropTypes.string,
  /**
   * A specific location to associate with this. This is only used when combined
   * with the setLocation prop.
   */
  location: locationType,
  /**
   * Triggered when the user clicks on the "from" button.
   */
  onFromClick: PropTypes.func,
  /**
   * Triggered when the user clicks on the "to" button.
   */
  onToClick: PropTypes.func,
  /**
   * The text to display on the "to" button for setting the destination of a trip.
   */
  toText: PropTypes.string,
  /**
   * Triggered when the user clicks either the "from" or "to" button and there
   * are no from/to specific handler functions defined as props.
   *
   * Passes an argument as follows:
   * { locationType: "from/to", location, reverseGeocode: false }
   */
  setLocation: PropTypes.func,
  /**
   * Determines whether icons are shown on the "from" and "to" buttons.
   */
  showIcons: PropTypes.bool
};

FromToLocationPicker.defaultProps = {
  fromText: i18n.t('fromHere'),
  location: null,
  onFromClick: null,
  onToClick: null,
  setLocation: null,
  showIcons: true,
  toText: i18n.t('toHere')
};

export default FromToLocationPicker;
